export type UpdateProjectMemoRequest = {
  pjtId: string;
  mmTxt: string;
  updateDateTime?: string;
};
